import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hrms1ax/mocker'
import env from 'src/../env.js'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hrms1ax/labels')
  },
  getIndex (searchParams) {
    if (isMock) return generator(mocker.index())
    let sendParams = {}
    let dteworkst = ''
    let dteworken = ''
    if (typeof searchParams !== 'undefined') {
      dteworkst = (typeof searchParams.dteworkst !== 'undefined' ? searchParams.dteworkst.replace(/\//g, '') : '')
      dteworken = (typeof searchParams.dteworken !== 'undefined' ? searchParams.dteworken.replace(/\//g, '') : '')
      sendParams = {
        p_codempid: (typeof searchParams.codempid !== 'undefined' ? searchParams.codempid : ''),
        p_codcomp2: (typeof searchParams.codcomp2 !== 'undefined' ? searchParams.codcomp2 : ''),
        p_codcalen: (typeof searchParams.codcalen !== 'undefined' ? searchParams.codcalen : ''),
        p_path: window.localStorage.getItem(env.site + '_baseURL') + 'file_uploads/'
      }
    }
    return instance().get(endpoint + '/hrms1ax/index/' + dteworkst + '/' + dteworken, { params: sendParams })
  }
}



// WEBPACK FOOTER //
// ./src/api/hrms1ax/index.js